module.exports = __webpack_public_path__ + "static/img/102415.f00a63ee.png";